import React from 'react';
import {
  Route, Switch,
} from 'react-router-dom';

import YourTourNav from '../YourTourNav/YourTourNav';
import Timeout from '../Timeout/Timeout';
import HomePage from '../HomePage/HomePage';
import InteractiveMapPage from '../InteractiveMapPage/InteractiveMapPage';
import AmenitiesPage from '../AmenitiesPage/AmenitiesPage';
import MediaPage from '../MediaPage/MediaPage';
import FloorPlansPage from '../FloorPlansPage/FloorPlansPage';

const ChromedComponents = () => (
  <>
    <YourTourNav />

    <Timeout />

    <Switch>
      {/* These components are full screen */}
      <Route
        path="/"
        exact
        component={HomePage}
      />

      <Route
        path="/map"
        exact
        component={InteractiveMapPage}
      />

      <Route
        path="/amenities"
        component={AmenitiesPage}
      />

      <Route
        path="/floor-plans"
        exact
        component={FloorPlansPage}
      />

      <Route
        path="/media"
        component={MediaPage}
      />

    </Switch>
  </>
);

export default ChromedComponents;
